import {
    FETCH_LABOS,
    FETCH_LABO_DETAIL,
    CREATE_LABO,
    UPDATE_LABO,
    DELETE_LABOS,
    FETCH_ACTIVE_LABOS
} from '@/redux/actions/types';

/**
 * Trạng thái khởi tạo cho module Labo
 */
const INIT_STATE = {
    list: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 30
        }
    },
    activeList: {
        items: [],
        pagination: {
            currentPage: 1,
            total: 0,
            perPage: 100
        }
    },
    detail: null,
    createResult: null,
    updateResult: null,
    deleteResult: null
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_LABOS: {
            return {
                ...state,
                list: {
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }

        case FETCH_ACTIVE_LABOS: {
            return {
                ...state,
                activeList: {
                    items: action.payload?.data || [],
                    pagination: {
                        currentPage: parseInt(action.payload.current_page),
                        total: parseInt(action.payload.total),
                        perPage: parseInt(action.payload.per_page),
                    }
                }
            };
        }

        case FETCH_LABO_DETAIL: {
            return {
                ...state,
                detail: action.payload || null
            };
        }

        case CREATE_LABO: {
            return {
                ...state,
                createResult: action.payload || null
            };
        }

        case UPDATE_LABO: {
            return {
                ...state,
                updateResult: action.payload || null
            };
        }

        case DELETE_LABOS: {
            return {
                ...state,
                deleteResult: action.payload || null
            };
        }

        default:
            return state;
    }
};
